import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { Button } from 'ustore-ui';

import { CustomInputComponent } from '../../../../shared/components/custom-input/custom-input.component';
import { BrazilState } from '../../../../shared/constants/brazil-states.constant';
import { I18nPipe } from '../../../../shared/pipes/i18n.pipe';
import { I18nService } from '../../../../core/services/i18n.service';

@Component({
  selector: 'umkt-register-step2',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, Button, CustomInputComponent, I18nPipe],
  templateUrl: './register-step2.component.html',
  styleUrls: [
    '../../../../../assets/style/login-register.component.scss',
    '../../register.component.scss'
  ]
})
export class RegisterStep2Component {
  private i18nService = inject(I18nService);

  @Input() step2Form!: FormGroup;
  @Input() brazilStates!: BrazilState[];
  @Input() showCitySuggestions = false;
  @Input() filteredCities: string[] = [];
  @Input() selectedSuggestionIndex = -1;
  @Input() citySelectedFromList = false;
  @Input() loading = false;

  @Input() nextStep!: () => void;
  @Input() preventLeadingSpace!: (event: KeyboardEvent) => void;
  @Input() onCityKeydown!: (event: KeyboardEvent) => void;
  @Input() selectCity!: (city: string) => void;
  @Input() goToLogin!: () => void;
  @Input() isFromMobileFlow!: () => boolean;
  @Input() customButtonTextKey?: string;
  @Input() hideAuthRegisterLink = false;

  getButtonText(): string {
    if (this.customButtonTextKey) {
      return this.i18nService.instant(this.customButtonTextKey);
    }

    return this.isFromMobileFlow()
      ? this.i18nService.instant('pages.register.step2.finishButton')
      : this.i18nService.instant('pages.register.step2.nextButton');
  }

  getButtonIcon(): any {
    return this.isFromMobileFlow() ? null : { name: 'arrow_forward', type: 'material-icons', position: 'right' };
  }
}


